import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { ArrowRight, MapPin } from "lucide-react";

/**
 * NotFound. calm catch-all 404 page.
 *
 * Rendered by App.js for any URL that doesn't match a defined route. Provides
 * the user a clear way back to the four most important destinations rather
 * than dead-ending them.
 */
export default function NotFound() {
 return (
 <div className="min-h-screen paper-grain" data-testid="not-found-page">
 <Navbar />
 <div className="max-w-2xl mx-auto px-6 sm:px-8 py-20 text-center">
 <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-[#E6F5F2] border border-[#1B6C62]/30">
 <MapPin size={24} strokeWidth={1.5} className="text-[#1B6C62]" />
 </div>
 <div className="label-mono mb-3 text-[#1B6C62]">404 · Lost the trail</div>
 <h1 className="font-serif text-4xl sm:text-5xl text-[#0D2B52] mb-4">This page doesn&apos;t exist</h1>
 <p className="text-[#333] font-serif leading-relaxed mb-10 max-w-md mx-auto">
 The link might be old, mistyped, or the page may have moved. Here are the most useful places to head:
 </p>

 <div className="grid sm:grid-cols-2 gap-3 mb-10 text-left">
 <Link to="/" className="card hover:border-[#1B6C62] transition-colors group" data-testid="not-found-link-home">
 <div className="label-mono mb-1 text-[#1B6C62]">Start here</div>
 <div className="font-serif text-[#0D2B52] group-hover:text-[#1B6C62] transition-colors">Home →</div>
 </Link>
 <Link to="/q" className="card hover:border-[#1B6C62] transition-colors group" data-testid="not-found-link-qa">
 <div className="label-mono mb-1 text-[#1B6C62]">Real tenant questions</div>
 <div className="font-serif text-[#0D2B52] group-hover:text-[#1B6C62] transition-colors">Q&amp;A library →</div>
 </Link>
 <Link to="/pricing" className="card hover:border-[#1B6C62] transition-colors group" data-testid="not-found-link-pricing">
 <div className="label-mono mb-1 text-[#1B6C62]">Plans &amp; pricing</div>
 <div className="font-serif text-[#0D2B52] group-hover:text-[#1B6C62] transition-colors">See pricing →</div>
 </Link>
 <Link to="/guide" className="card hover:border-[#1B6C62] transition-colors group" data-testid="not-found-link-guide">
 <div className="label-mono mb-1 text-[#1B6C62]">How TenantTrail works</div>
 <div className="font-serif text-[#0D2B52] group-hover:text-[#1B6C62] transition-colors">Help &amp; guide →</div>
 </Link>
 </div>

 <Link to="/register" className="btn-primary inline-flex items-center gap-2" data-testid="not-found-cta">
 Start free <ArrowRight size={14} strokeWidth={1.5} />
 </Link>
 </div>
 </div>
 );
}
